import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';
import { SearchServices } from '../../components/search-services/search-services';
import { GeAdsComponent } from '../../components/ge-ads/ge-ads';
import { VolunteerCardComponent } from '../../components/volunteer-card/volunteer-card';
import { GigService } from '../../core/gig.service';
import { JobService } from '../../core/job.service';
import { VolService } from '../../core/vol.service';
import { AdService } from '../../core/ad.service';
import { environment } from '../../../environments/environment';
import { globals } from '../../../environments/globals';

@Component({
    imports: [
        CommonModule, 
        FooterComponent, 
        FooterDesktopComponent, 
        GeAdsComponent, 
        HeaderComponent, 
        HeaderDesktopComponent, 
        SearchServices, 
        VolunteerCardComponent
    ],
    selector: 'app-home',
    standalone: true,
    host: { ngSkipHydration: 'true' },
    styleUrls: ['home.page.scss'],
    templateUrl: 'home.page.html'
})
export class HomePage implements OnInit {
  webURL: string = environment.webURL;
  appURL: string = environment.appURL;
  mediaURL: string = environment.mediaURL;
  slug: string | null = 'global';
  match: boolean = false;
  country: any;
  countries: any[] = globals.countries.filter((site: { current: boolean; }) => site.current);
  search: boolean = false;
  gigtown: boolean = false;
  explainer: boolean = false;
  gigsintown: any;
  showgigs: boolean = false;
  jobsintown: any;
  showjobs: boolean = false;
  volsintown: any;
  showvols: boolean = false;
  adsintown: any;
  showads: boolean = false;
  getSearch: string = '';
  getOption: string = '';
  errorSearch: boolean = false;
  errorOption: boolean = false;
  title: string = 'Future of Work Jobs & Gig Economy Gigs';
  description: string = 'Future of Work Jobs & Freelancer, Contractor & Consultant Gig Economy Website. Advertise permanent & contract jobs. Full-time, part-time, casual & temporary jobs on our global job board. Promote and advertise your small business work service. List & post freelance gigs. Find & Hire volunteers, digital nomads, remote workers & side hustle marketplace. Recruit job seekers looking for flexible work, WFH & WFA  on our global job platform and gig economy app in Australia, Austria, Belgium, Bulgaria, Canada, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hong Kong, Hungary, Ireland, Italy, Japan, Latvia, Lithuania, Luxembourg, Malaysia, Malta, Netherlands, New Zealand (NZ), Norway, Peru, Poland, Portugal, Romania, Singapore, Slovakia, Slovenia, Spain, Sweden, Switzerland, United Arab Emirates (UAE), United Kingdom (UK) & United States of America (USA).';

  constructor(
    private gs: GigService,
    private js: JobService,
    private vs: VolService,
    private as: AdService,
    private metaService: Meta,
    private router: Router,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.metaService.updateTag({ name: 'description', property: 'og:description', content: this.description });
    this.showgigs = true;
    this.loadAds();
  }

  loadAds() {
    this.gs.gigs().subscribe(gigs => {
      this.gigsintown = gigs;
    });
    this.js.jobs().subscribe(jobs => {
      this.jobsintown = jobs;
    });
    this.vs.vols().subscribe(vols => {
      this.volsintown = vols;
    });
    this.as.ads().subscribe(ads => {
      this.adsintown = ads;
    });
  }

  show(service: string) {
    this.showgigs = false;
    this.showjobs = false;
    this.showvols = false;
    this.showads = false;
    if (service == 'gigs') {
      this.showgigs = true;
    }
    if (service == 'jobs') {
      this.showjobs = true;
    }
    if (service == 'vols') {
      this.showvols = true;
    }
    if (service == 'ads') {
      this.showads = true;
    }
  }

  goToSearch() {
    let self = this;
    let keyword = false;
    let option = false;

    // Checks if search keyword value
    if (this.getSearch != '') {
      option = true;
      this.errorSearch = false;
    } else {
      this.errorSearch = true;

      setTimeout(function() {
        self.errorSearch = false;
      }, 5000);
    }

    // Checks if option value
    if (this.getOption != '') {
      keyword = true;
      this.errorOption = false;
    } else {
      this.errorOption = true;

      setTimeout(function() {
        self.errorSearch = false;
      }, 5000);
    }

    // redirect to pages
    if ( keyword && option ) {
      let url = '/' + this.getOption.toLowerCase();
      this.router.navigate([url], { queryParams: { query: this.getSearch } });
    }
  }
}
